module.exports = __webpack_public_path__ + "static/img/img3.2fd98e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img3.png
// module id = 0dir
// module chunks = 0